@if (showEnterpriseDashboard()) {
  <app-dashboard />
} @else {
<div class="section no-pad-bot">
  <div class="">
    <div class="row">
      <div class="col s12 l6">
        <div class="card" id="receivedAlertsCard">
          <div class="card-content">
            <div style="float: right">
              <button mat-stroked-button (click)="onMarkAllRead()" style="margin-left: 1rem">
                {{ 'Mark All as Read' | translate: locale.language }}
              </button>
            </div>
            <span class="card-title" id="{{ 'AlertsReceived' }}">{{ 'AlertsReceived' | translate: locale.language }}</span>
            <div style="float: right">
              <mat-slide-toggle (change)="onUnreadToggle($event.checked)">{{ 'Show Unread Only' | translate: locale.language }}</mat-slide-toggle>
            </div>
            <p id="recentReceivedMessage">
              {{ 'RecentAlerts10' | translate: locale.language }}
              <strong id="receivedMessage">{{ 'ReceivedLC' | translate: locale.language }}</strong>.
            </p>
            <div style="min-height: 8px; margin-top: 0.5rem">
              <app-loading [isCircle]="false" [hasLoaded]="!fetchRecvInProgress"></app-loading>
            </div>
            <div class="collection" id="receivedAlertsList">
              @for (alert of alertsReceived; track alert.id) {
                <div class="collection-item avatar" id="receivedAlert">
                  <!-- TF-725 will remove the ngIf -->
                  <div class="right buttonRow">
                    <mat-menu #appMenu="matMenu" yPosition="below" xPosition="before" [overlapTrigger]="false">
                      <button mat-menu-item (click)="openHideDialog(alert)">
                        <mat-icon>visibility_off</mat-icon>
                        <span>{{ 'Hide' | translate: locale.language }}</span>
                      </button>
                    </mat-menu>
                    <button
                      class="menu-btn"
                      mat-icon-button
                      [matMenuTriggerFor]="appMenu"
                      [disableRipple]="true"
                      aria-label="Alert actions">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>
                  <div class="as-secondary-content">
                    <span id="dateTimeReceived">
                      {{ alert?.timeSent | fixDate | date }} <br />{{ alert?.timeSent | fixDate | date: 'shortTime' }}
                      <br />
                      <app-alert-detail-icons [alert]="alert"></app-alert-detail-icons>
                    </span>
                    <br />
                  </div>
                  <div>
                    <div
                      class="circle as-icon"
                      [ngClass]="[
                        alert?.message?.priority === 'Emergency' ? 'red' : 'blue',
                        alert?.alertType === 'Poll' ? 'poll' : 'alert',
                      ]"></div>
                    <span class="title">
                      <b>
                        <a
                          [routerLink]="['/alerts/received', alert?.id]"
                          class="subject truncate"
                          id="singleReceivedMessage">
                          {{ alert?.message?.basic?.subject }}
                        </a>
                      </b>
                    </span>
                    <p>{{ getIncidentName(alert?.message) }}&nbsp;</p>
                    <p id="singleReceivedSender">
                      @if (alert?.sender?.asset?.name !== null) {
                        <span>{{ alert?.sender?.asset?.name + ',' }}</span>
                      }
                      {{ alert?.sender?.displayName }}
                    </p>
                  </div>
                </div>
              }
              @if (alertsReceived?.length === 0) {
                <div style="padding: 1rem" class="as-grey-text">
                  {{ 'No Alerts Received' | translate: locale.language }}
                </div>
              }
            </div>
            <!-- Loading Spinner -->
            @if (!alertsReceived) {
              <div class="row loading-centered">
                <app-loading [hasLoaded]="!!alertsReceived"></app-loading>
              </div>
            }
            <a
              mat-raised-button
              color="primary"
              routerLink="/alerts/received"
              [queryParams]="{ type: 'map' }"
              id="viewOnMapReceived">
              {{ 'ViewOnMap' | translate: locale.language }}
            </a>
          </div>
        </div>
      </div>
      <div class="col s12 l6">
        <div class="card" id="sentAlertsCard">
          <div class="card-content">
            <span class="card-title" id="{{ 'AlertsSent' }}">{{ 'AlertsSent' | translate: locale.language }}</span>
            <p id="recentSentMessage">
              {{ 'RecentAlerts10' | translate: locale.language }}
              <strong id="sentMessage">{{ 'SentLC' | translate: locale.language }}</strong>.
            </p>
            <div style="min-height: 8px; margin-top: 0.5rem">
              <app-loading [isCircle]="false" [hasLoaded]="!fetchSentInProgress"></app-loading>
            </div>
            <div class="collection" id="sentAlertsList">
              @for (alert of alertsSent; track alert.id) {
                <div class="collection-item avatar" id="sentAlert">
                  <span class="as-secondary-content" id="dateTimeSent">
                    {{ alert?.timeSent | fixDate | date }}
                    <br />{{ alert?.timeSent | fixDate | date: 'shortTime' }}
                    <br /><app-alert-detail-icons [alert]="alert"></app-alert-detail-icons>
                  </span>
                  <div>
                    <div
                      class="circle as-icon"
                      [ngClass]="[
                        alert?.message?.priority === 'Emergency' ? 'red' : 'blue',
                        alert?.alertType === 'Poll' ? 'poll' : 'alert',
                      ]"></div>
                    <span class="title">
                      <b>
                        <a [routerLink]="['/alerts', alert?.id]" class="subject truncate" id="singleSentMessage">{{ alert?.message?.basic?.subject }}</a>
                      </b>
                    </span>
                    <p>{{ getIncidentName(alert?.message) }}&nbsp;</p>
                    <p id="singleSentSender">
                      @if (alert?.sender?.asset?.name !== null) {
                        <span>{{ alert?.sender?.asset?.name + ',' }}</span>
                      }
                      {{ alert?.sender?.displayName }}
                    </p>
                  </div>
                </div>
              }
              @if (alertsSent?.length === 0) {
                <div style="padding: 1rem" class="as-grey-text">
                  {{ 'No Alerts Sent' | translate: locale.language }}
                </div>
              }
            </div>
            <!-- Loading Spinner -->
            @if (!alertsSent) {
              <div class="row loading-centered">
                <app-loading [hasLoaded]="!!alertsSent"></app-loading>
              </div>
            }
            <a
              mat-raised-button
              color="primary"
              routerLink="/alerts/sent"
              [queryParams]="{ type: 'map' }"
              id="viewOnMapSent">
              {{ 'ViewOnMap' | translate: locale.language }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
